// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"5fb842b3","211":"d8e5a127","638":"63e5aa76"}[chunkId] + ".chunk.js";
};